import { render } from "./Hero.vue?vue&type=template&id=c9f5c00e"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=c9f5c00e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__